<svg viewBox="-4 -4 108 108" width="1rem" height="1rem">
  <circle r="4" cx="40" cy="0"></circle>
  <circle r="4" cx="60" cy="0"></circle>
  <circle r="4" cx="0" cy="40"></circle>
  <circle r="4" cx="0" cy="60"></circle>
  <circle r="4" cx="100" cy="40"></circle>
  <circle r="4" cx="100" cy="60"></circle>
  <circle r="4" cx="40" cy="100"></circle>
  <circle r="4" cx="60" cy="100"></circle>
  <circle r="6" cx="20" cy="20"></circle>
  <circle r="6" cx="40" cy="20"></circle>
  <circle r="6" cx="60" cy="20"></circle>
  <circle r="6" cx="80" cy="20"></circle>
  <circle r="6" cx="20" cy="40"></circle>
  <circle r="6" cx="20" cy="60"></circle>
  <circle r="6" cx="80" cy="40"></circle>
  <circle r="6" cx="80" cy="60"></circle>
  <circle r="6" cx="20" cy="80"></circle>
  <circle r="6" cx="40" cy="80"></circle>
  <circle r="6" cx="60" cy="80"></circle>
  <circle r="6" cx="80" cy="80"></circle>
  <circle r="9" cx="40" cy="40"></circle>
  <circle r="9" cx="60" cy="40"></circle>
  <circle r="9" cx="40" cy="60"></circle>
  <circle r="9" cx="60" cy="60"></circle>
</svg>
